export default "__VITE_ASSET__6cef59f9__"